<template>
    <div class="modal" @mousedown.self="hideModal()">
      <div class="modal-dialog modal-dialog-sm">
        <div class="popup-header -border -small-font">{{linkId ? 'Edit' : 'Add new'}} {{$lang.messages.add_link_modal.link}} <span class="modal-close" @click="hideModal()"><svg class="modal-close-icon"><use xlink:href="#icon-close"></use></svg></span></div>
        <div class="popup-sections-wrapper">
          <div class="popup-section">
            <h3>{{$lang.messages.add_link_modal.create_link}}</h3>
            <p>{{$lang.messages.add_link_modal.create_link_desc}}</p>
            <div class="link-form-wrapper">
              <div class="link-form">
                <input type="text" v-model="title" :placeholder="$lang.messages.add_link_modal.enter_link_title" class="form-control" maxlength="75" required>
                <input type="url" v-model="url" :placeholder="$lang.messages.add_link_modal.enter_link_url" pattern="(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)" class="form-control" required @keyup.enter="addLink()">
              </div>
              <div class="link-form-footer" :class="{'-align-between': isAndroid}">
                <button class="btn btn-outline" @click="removeLink()" v-if="isEdit && isAndroid">{{ $lang.messages.remove }} {{ $lang.messages.link }}</button>
                <button class="btn btn-primary" @click="addLink()">{{linkId ? $lang.messages.edit : $lang.messages.add }}
                  {{ $lang.messages.link }}</button>
              </div>
            </div>
          </div>
          <div class="popup-section" v-if="showRecommededBlock">
            <div class="shortcut-tabs-wrapper">
              <div class="shortcuts-tabs">
                <div v-for="(item, index) in categories" :key="index" class="radio-label shortcut-tab-item"
                       :class="{active: activeTab === item}"
                       @click="activeTab = item"
                >
                  {{item}}
                </div>
              </div>
              <div class="shortcut-tabs-data">
                <div class="popup-link-list">
                  <div :key="index"
                         v-for="(link, index) in activeList"
                         class="popup-link flex flex-v-top">
                      <div class="popup-link-icon">
                        <img :src="'https://www.google.com/s2/favicons?sz=64&domain=' + link.url" :alt="link.title">
                      </div>
                      <div class="popup-link-content">
                        <div class="popup-link-header flex-between">
                          <a :href="link.url" target="_blank" class="popup-link-title text-md">
                            {{link.title}}
                          </a>
                        </div>
                        <div class="popup-link-text text-sm" :title="link.desc">
                          {{link.desc}}
                        </div>
                      </div>
                      <div class="popup-link-btn" @click="addLinkFromList(link)">+</div>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { recommendedLinksPopup } from '../helpers/configs'
import { isValidURL } from '../helpers/utils'

export default {
  name: 'AddLinkModal',
  props: ['linktitle', 'linkurl', 'linkId', 'kidAge', 'recommended', 'isEdit'],
  data: function () {
    return {
      title: this.linktitle,
      url: this.linkurl || 'https://',
      activeTab: 'Education',
      categories: ['Education', 'Games', 'Video', 'Portal', 'Music'],
      recommendedLinksPopup,
      isAndroid: window.Android
    }
  },
  computed: {
    activeList() {
      return this.recommendedLinksPopup.filter(link => link.category === this.activeTab && (link.age === this.kidAge || link.age === 'all'));
    },
    showRecommededBlock(){
      return this.recommended !== false
    }
  },

  methods: {
    hideModal () {
      this.$emit('hidemodal')
    },
    addLink(){
      this.addLinkFromList(this);
    },
    addLinkFromList(item) {
      try {
        const httpsProtocol = 'https://';
        const httpProtocol = 'http://';
        let convertedUrl = item.url;
        if (!convertedUrl.includes(httpsProtocol) && !convertedUrl.includes(httpProtocol)) {
          convertedUrl = httpsProtocol + convertedUrl
        }
        if (isValidURL(convertedUrl)) {
          const {origin} = new URL(convertedUrl);
          const icon = 'https://www.google.com/s2/favicons?sz=64&domain=' + origin + '';
          const link = {
            id: Date.now(),
            title: item.title,
            url: convertedUrl,
            icon: icon
          }

          this.$emit('addlink', link, this.isEdit)
        } else  {
          this.$dtoast.pop({
            preset: "error",
            heading: item.url + " URL is invalid",
          })
        }
      } catch (e) {
        this.$dtoast.pop({
          preset: "error",
          heading: item.url + " URL is invalid",
        })
      }
    },
    removeLink () {
      this.$emit('removelink', this.linkId);
      this.$emit('hidemodal');
    }
  },
}
</script>

<style lang="scss">
@import "../assets/styles/helpers";

.popup-header,
.popup-sections-wrapper {
  padding: 10px 20px;
}

.popup-section h3 {
  margin: 10px 0;
}

.shortcut-tab-item {
  padding: 5px 15px;

  input {
    position: absolute;
    opacity: 0;
    visibility: hidden;
  }
}

.modal-close {
  cursor: pointer;
}

.popup-link-text {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.input {
  width: 100%;
  background: #FFFFFF;
  border: 1px solid #E2E2E2;
  border-radius: 8px;
  padding: 8px 15px;
  font-size: 1rem;
  margin-bottom: 10px;

  &:focus {
    border-color: #7D6AED;
    outline: none;
  }
}

.input::placeholder {
  color: #828282;
}

.link-form-icon {
  background: #EFF0F7;
  border-radius: 8px;
  width: 82px;
  height: 82px;
  margin-right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  text-align: center;

  @include responsive-below($xs){
    width: 50px;
    height: 50px;
    padding: 10px;
  }
}

.link-form {
  margin-bottom: 6px;

  .form-control {
    margin-bottom: 10px;
    padding: 8px 10px;
  }
}

.link-form-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;

  &.-align-between {
    justify-content: space-between;
  }
}

.link-form-wrapper {
  margin-bottom: 12px;
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
  position: relative;
  z-index: 1;
}

.shortcuts-tabs {
  background: #EFF0F7;
  padding: 5px 20px;
  margin-bottom: 15px;
  border-top: 1px solid #ACB3CB;
  border-bottom: 1px solid #ACB3CB;

  @include responsive-below($xs){
    display: flex;
    overflow: auto;
    max-width: calc(100vw + 40px);
  }
}

.shortcut-tabs-wrapper {
  margin: 0 -20px;
}

.shortcut-item {
  padding: 14px 20px 10px 20px;
  border-bottom: 1px solid #A59C9A;
  display: flex;
  align-items: center;
  width: 100%;
}

.shortcut-item:last-child {
  border-bottom: none;
}

.shortcut-title, .shortcut-desc {
  font-size: 16px;
}

.shortcut-info {
  margin-right: 10px;
  flex: 0 0 330px;
  max-width: 330px;
  width: 100%;
  cursor: pointer;
  padding-left: 15px;
}

.shortcut-tabs-data {
  height: 330px;
  overflow: auto;
}

.shortcut-desc {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.shortcut-tab-item {
  display: inline-block;
  text-decoration: none;
  text-transform: uppercase;
  padding: 10px 20px;
  border-radius: 60px;
  font-weight: 700;
  cursor: pointer;
}

.shortcut-tab-item.active {
  background: #fff;
}

.shortcut-icon {
  width: 16px;
  margin-top: 10px;
  align-self: flex-start;
}

.shortcut-tabs-data .btn-add {
  text-align: center;
  font-size: 30px;
  padding: 5px;
}

.popup-section p {
  margin-bottom: 5px;
  margin-top: 0;
}

.deleteButton, .addButton {
  font-size: 16px!important;
  color: #A5A5A5;
  font-weight: 400;
  text-decoration: underline;
  outline: none;
  background: transparent;
  padding: 0;
  border: none;
  cursor: pointer;
}

.deleteButton:hover, .addButton:hover {
  text-decoration: none;
}

.addButton {
  color: #39FF65;
}

.popup-header {
  font-size: 24px;
  font-weight: 700;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;

  &.-border {
    border-bottom: solid 1px #ACB3CB;
    justify-content: space-between;
  }
  &.-small-font {
    font-size: 18px;
  }
  &.-align-end {
    justify-content: flex-end;
  }
  &.-between {
    justify-content: space-between;
  }
}

.shortcut-tab-data.links-block-content {
  max-height: 100%;
}

.hidden {
  display: none;
}


/* The Modal (background) */
.modal {
  position: fixed; /* Stay in place */
  z-index: 11; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgba(0,0,0,0.4); /* Black w/ opacity */


  &-dialog{
    background: #fff;
    backdrop-filter: blur(40px);
    border-radius: 20px;
    overflow: hidden;
    position: absolute;
    top: 100px;
    left: 50%;
    width: 600px;
    transform: translateX(-50%);
    margin: auto;
    border: 0;
    padding: 0;
    max-width: 100%;

    @include responsive-below($sm){
      max-width: 90%;
      top: 5vw;
    }

    &-sm {
      width: 470px;
    }

    &-lg {
      width: 850px;
    }
    &-xlg {
      width: 1150px;
    }
  }

  &-footer {
    padding: 20px;
  }

  &-content {
    background-color: #fff;
    padding: 20px;

    &-narrow {
      width: 70%;

      @include responsive-below($sm){
        width: 100%;
      }
    }
  }

  &-title {
    font-size: 24px;
    font-weight: 700;
    padding: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &.modal-color {
    .modal-dialog {
      background: linear-gradient(180deg, #A39CFF 0%, #CDE4FF 100%), #FFFFFF;
    }

    .modal-content {
      background-color: transparent;
      padding: 24px 54px;

      @include responsive-below($sm){
        padding: 20px;
      }

      &.-wide {
        padding: 24px 24px 24px 54px;
      }
    }

    .modal-title {
      color: #fff;
      font-size: 30px;
      justify-content: flex-start;

      @include responsive-below($sm){
        font-size: 21px;
      }
    }

    .modal-close {
      position: absolute;
      right: 24px;
      top: 24px;

      i:before {
        color: #fff;
      }
    }
  }
  @include responsive-below($xs){
    &-dialog {
      top: 0;
      width: 100%;
      max-width: 425px;
      margin: 0 auto;
      transform: none;
      left: 0;
      right: 0;
      border-radius: 0;
      min-height: 100%;
    }
  }
}

.popup-link {
  padding: 15px 20px;
  border-bottom: solid 1px #ACB3CB;

  &:last-child {
    border-bottom: 0;
  }

  &-icon {
    min-width: 32px;
    max-width: 32px;
    margin-right: 10px;
  }

  &-content {
    width: 100%;
  }

  &-title {
    color: #27272c;
    text-decoration: none;
  }
  
  &-btn {
    margin-left: 24px;
    border: 1px solid #272324;
    border-radius: 60px;
    font-size: 40px;
    min-width: 36px;
    height: 36px;
    text-align: center;
    line-height: 30px;
    cursor: pointer;
  }

  &-header {
    margin-bottom: 10px;
  }

  &-rating i {
    margin-left: 5px;
  }
}

</style>


